/**
 * Generic javascript goes here
 * TODO: Not es6 :(
 */

jQuery(document).ready(function ($) {
  function lockScroll() {
    var $html = jQuery('html');
    var $body = jQuery('body');
    var initWidth = $body.outerWidth();
    var initHeight = $body.outerHeight();

    var scrollPosition = [
      self.pageXOffset ||
        document.documentElement.scrollLeft ||
        document.body.scrollLeft,
      self.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop,
    ];
    $html.data('scroll-position', scrollPosition);
    $html.data('previous-overflow', $html.css('overflow'));
    $html.css('overflow', 'hidden');
    window.scrollTo(scrollPosition[0], scrollPosition[1]);

    var marginR = $body.outerWidth() - initWidth;
    var marginB = $body.outerHeight() - initHeight;
    $body.css({ 'margin-right': marginR, 'margin-bottom': marginB });
  }

  function unlockScroll() {
    var $html = jQuery('html');
    var $body = jQuery('body');
    $html.css('overflow', $html.data('previous-overflow'));
    var scrollPosition = $html.data('scroll-position');
    window.scrollTo(scrollPosition[0], scrollPosition[1]);

    $body.css({ 'margin-right': 0, 'margin-bottom': 0 });
  }

  var s,
    Tha = {
      /**
       * General settings to be used
       */
      settings: {
        equalHeight: {
          parentSelector: '.js-equal-height',
          childSelector: '.js-equal-height__child a',
        },
      },

      /**
       * Boot up
       */
      init: function () {
        s = this.settings;
        this.bindUIActions();
        this.equalHeight();
      },

      /**
       * Anything that requires binding to interactions (click, hover etc);
       */
      bindUIActions: function () {},

      /**
       * Any additional methods
       * Call as either part of init, within a UI action, or something else
       */

      /**
       * Look for anything with a class name, make them the same height
       * TODO: Responsive changes?
       */
      equalHeight: function () {
        var selector = this.settings.equalHeight.parentSelector;
        var childSelector = this.settings.equalHeight.childSelector;
        if (
          document.querySelector(selector) &&
          document.querySelectorAll(selector).length >= 1
        ) {
          var blocks = document.querySelectorAll(selector);
          for (var i = 0; i < blocks.length; i++) {
            var block = blocks[i];
            var blockHeight = 0;
            var children = block.querySelectorAll(childSelector);
            if (children && children.length > 1) {
              for (var x = 0; x < children.length; x++) {
                var child = children[x];
                if (child.offsetHeight > blockHeight) {
                  blockHeight = child.offsetHeight;
                }
              }
              for (var x = 0; x < children.length; x++) {
                var child = children[x];
                child.style.height = blockHeight + 'px';
              }
            }
          }
        }
      },
    };

  /**
   * Load once the page is ready
   */
  (function () {
    Tha.init();
  })();

  /*
    // $('#__ba_panel').addClass('is-hidden')
  
    // Show browsealoud widget when clicking link in footer
    $('a[href="#browsealoud"]').on('click', function(e) {
      e.preventDefault()
      $('#__ba_panel').show()
      $('#__ba_panel a').click()
    })
  */
  var selectId = $('#pl_category_id');

  $(selectId).on('change', function (e) {
    //e.preventDefault();

    var url = window.location.href;
    var isPagination = url.split('?')[0].indexOf('/page/');
    if (isPagination) {
      $(selectId)
        .closest('form')
        .attr('action', url.substr(0, isPagination + 1));
    }
    $(selectId).closest('form').submit();
  });

  /**
   *--------------------------------------------------------------------------
   * Component: Category Filter
   *--------------------------------------------------------------------------
   */
  $('.c-filters__title').click(function () {
    $('main#main').toggleClass('u-no-overflow');
    $('.c-filters__menu').toggleClass('open').slideToggle(200);
    $(this).toggleClass('active');
    $('.c-filters__arrow').toggleClass('open');
  });

  /**
   *--------------------------------------------------------------------------
   * Component: Site nav
   *--------------------------------------------------------------------------
   */
  var $siteNav = $('.c-site-nav');
  var $siteNavToggle = $('.js-site-nav--toggle');
  var $siteNavItem = $('.c-site-nav__item');

  $siteNavToggle.on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var isActive = $siteNav.hasClass('is-active');
    $('html, body').animate(
      {
        scrollTop: $('body').offset().top - 10,
      },
      300
    );

    if (!isActive) {
      // Show Nav
      $this.addClass('is-active');
      $siteNav.addClass('is-active');
      $this.attr('aria-expanded', 'true');
      $siteNav.attr('aria-hidden', 'false');
      $siteNav
        .find('.c-site-nav__menu:first-of-type .c-site-nav__item:first-of-type')
        .focus();
    } else {
      // Hide Nav
      $this.removeClass('is-active');
      $siteNav.removeClass('is-active');
      $this.attr('aria-expanded', 'false');
      $siteNav.attr('aria-hidden', 'true');
    }
  });

  if ($(window).width() < 992) {
    // Main dropdown
    $('.c-site-nav__dropdown')
      .prev()
      .on('click', function () {
        console.log('click');
        var submenu = $(this).next('.c-site-nav__dropdown');
        if ($(submenu).is(':hidden')) {
          $(submenu).slideDown(200);
          $(submenu).parent().addClass('is-open');
        } else {
          $(submenu).slideUp(200);
          $(submenu).parent().removeClass('is-open');
        }
      });
  }

  $siteNavItem.hover(
    function (e) {
      var $this = $(this);
      $this.addClass('is-active');
      var $thisDropdown = $this.find('.c-site-nav__dropdown');

      if ($thisDropdown.length >= 1) {
        // do something with the dropdown
      }
    },
    function () {
      $(this).removeClass('is-active');
    }
  );

  jQuery('.c-sub-nav, .c-sub-nav__panel').menuAim({
    activate: activateSubNav,
    deactivate: deactivateSubNav,
    exitMenu: deactivateSubNav,
  });

  function activateSubNav(row) {
    jQuery(row).addClass('is-active');
  }

  function deactivateSubNav(row) {
    jQuery(row).removeClass('is-active');
    jQuery(row).find('.c-sub-nav__item').removeClass('is-active');
    return true;
  }

  /**
   *--------------------------------------------------------------------------
   * Component: Emergency Notice
   *--------------------------------------------------------------------------
   */

  var $noticeClose = $('.c-emergency-notice__close');
  $noticeClose.click(function () {
    // Close Notice
    $(this).parent().addClass('is-closed');
  });
  /**
   *--------------------------------------------------------------------------
   * Component: Carousel
   *--------------------------------------------------------------------------
   */
  $slickCarousel = $('.js-carousel');
  $slickCarousel.slick({
    arrows: true,
    appendArrows: '.c-carousel__arrows',
    nextArrow:
      '<button type="button" class="slick-next u-hide-text">Next Slide</button>',
    prevArrow:
      '<button type="button" class="slick-prev u-hide-text">Previous Slide</button>',
    centerMode: true,
    dots: true,
    dotsClass: 'c-carousel__dots',
    appendDots: '.c-carousel__dots-container',
    infinite: false,
    mobileFirst: true,
    variableWidth: false,
    centerPadding: '0px',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          centerMode: false,
          speed: 400,
          fade: true,
          cssEase: 'linear',
          centerPadding: '0px',
        },
      },
    ],
  });
  /**
   *--------------------------------------------------------------------------
   * Component: Featured Content Slider
   *--------------------------------------------------------------------------
   */

  $('.c-featured-content-slider__slider').slick({
    arrows: true,
    nextArrow:
      '<button type="button" class="c-featured-content-slider__arrow-button slick-next">Next Slide</button>',
    prevArrow:
      '<button type="button" class="c-featured-content-slider__arrow-button slick-prev">Previous Slide</button>',
    centerMode: false,
    dots: false,
    infinite: true,
    mobileFirst: true,
    variableWidth: false,
    centerPadding: '30px',
    dotsClass: 'c-featured-content-slider__dots',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          speed: 400,
          fade: true,
          cssEase: 'linear',
          arrows: false,
          dots: true,
        },
      },
    ],
  });

  /**
   *--------------------------------------------------------------------------
   * Component Module: Wide Content Slider
   *--------------------------------------------------------------------------
   */
  $slickWideContentSlider = $('.js-wide-content-slider');
  $slickWideContentSlider.slick({
    regionLabel: 'Wide Content Carousel',
    arrows: true,
    appendArrows: '.c-carousel__arrows',
    nextArrow:
      '<button type="button" class="slick-next u-hide-text">Next Slide</button>',
    prevArrow:
      '<button type="button" class="slick-prev u-hide-text">Previous Slide</button>',
    centerMode: true,
    dots: true,
    dotsClass: 'c-carousel__dots',
    appendDots: '.c-carousel__dots-container',
    infinite: false,
    mobileFirst: true,
    variableWidth: false,
    centerPadding: '0px',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          centerMode: false,
          speed: 400,
          fade: true,
          cssEase: 'linear',
          centerPadding: '0px',
        },
      },
    ],
  });

  /**
   *--------------------------------------------------------------------------
   * Component: Homepage Slider
   *--------------------------------------------------------------------------
   */
  $slickHpHero = $('.js-hp-slider');
  $slickHpHero.slick({
    accessibility: false,
    arrows: false,
    centerMode: false,
    dots: false,
    infinite: true,
    mobileFirst: true,
    variableWidth: false,
    centerPadding: '30px',
    dotsClass: 'c-carousel__dots',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          speed: 400,
          fade: true,
          cssEase: 'linear',
          arrows: false,
          dots: true,
        },
      },
    ],
  });

  /**
   *--------------------------------------------------------------------------
   * Component Module: Image slider
   *--------------------------------------------------------------------------
   */
  $slickImageSlider = $('.js-image-slider');
  $slickImageSlider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    appendArrows: '.c-carousel__arrows',
    nextArrow:
      '<button type="button" class="slick-next u-hide-text">Next Slide</button>',
    prevArrow:
      '<button type="button" class="slick-prev u-hide-text">Previous Slide</button>',
    fade: true,
    dots: true,
    // asNavFor: '.js-image-slider-nav',
    dotsClass: 'c-carousel__dots',
    appendDots: '.c-carousel__dots-container',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          speed: 400,
          fade: true,
          cssEase: 'linear',
          dots: true,
          arrows: false,
        },
      },
    ],
  });

  // $slickImageSliderNav = $('.js-image-slider-nav');
  // $slickImageSliderNav.slick({
  //     slidesToShow: 6,
  //     slidesToScroll: 1,
  //     infinite: true,
  //     asNavFor: '.js-image-slider',
  //     dots: false,
  //     centerMode: false,
  //     centerPadding: '1px',
  //     focusOnSelect: true
  // });

  /**
   *--------------------------------------------------------------------------
   * Component: Accordion
   *--------------------------------------------------------------------------
   */
  var $accordion = $('.c-accordion');
  var $accordionItem = $('.c-accordion__item');
  var $accordionTitle = $('.c-accordion__title');
  var $accordionContents = $('.c-accordion__content');

  /*
    $accordionContents.hide()
  
    $accordionTitle.on('click', function (e) {
      e.preventDefault()
      $(this).parent().toggleClass('is-active')
    })
    */

  // Add class "is-active" to first element
  $('.c-accordion > .c-accordion__item:first-child').addClass('is-active');
  // (Optional) Active an item if it has the class "is-active"
  $('.c-accordion > .c-accordion__item.is-active')
    .children('.c-accordion__content')
    .slideDown();

  $accordionTitle.click(function (e) {
    e.preventDefault();
    var timeoutID;
    var $this = $(this);

    if ($('.c-accordion__item.scrollup').length) {
      smoothScrollToElement($this, 300);
      console.log('yes yes');
    }

    /*
      if ( $('.c-accordion__item.scrollup')) {
         smoothScrollToElement($this, 300)
         console.log('yes')
      }
  */

    // Cancel other parents
    $(this)
      .parent()
      .siblings('.c-accordion__item')
      .removeClass('is-active')
      .children('.c-accordion__content')
      .slideUp();

    // Toggle the item
    $this
      .parent()
      .toggleClass('is-active')
      .children('.c-accordion__content')
      .slideToggle('ease-out', function () {
        // when complete smooth scroll to the top of the item

        if ($('.c-accordion__item.scrollup').length) {
          smoothScrollToElement($this, 300);
          console.log('yes yes');
        }
      });
  });

  /**
   *--------------------------------------------------------------------------
   * Useful links in the header (Services)
   *--------------------------------------------------------------------------
   */

  if ($(window).width() < 1009) {
    if ($('.c-useful-links').hasClass('c-useful-links--in-header')) {
      $('.c-useful-links--in-header').insertAfter('.c-breadcrumbs');
      $('.c-accordion--useful-links__item').removeClass('is-active');
      $('.c-accordion--useful-links__content').slideUp();
    }
  } else {
    if ($('.c-useful-links').hasClass('c-useful-links--in-header')) {
      $('.c-useful-links--in-header .c-accordion--useful-links__title').off(
        'click'
      );
      $('.l-content-page__aside').prepend($('.c-useful-links--in-header'));
      $('.c-accordion__item').unbind('click');
    }
  }

  /**
   *--------------------------------------------------------------------------
   * Scroll to top link
   *--------------------------------------------------------------------------
   */
  // Check to see if the window is top if not then display button
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $('.js-scroll-to-top').fadeIn();
    } else {
      $('.js-scroll-to-top').fadeOut();
    }
  });

  // Change focus to the top most link, in this case Skip to content
  $('.js-scroll-to-top').click(function () {
    $('html, body').animate({ scrollTop: 0 }, 800);
    $('#top-focus').focus();
    return false;
  });

  /**
   *--------------------------------------------------------------------------
   * Smooth Scroll: (any link with class .js-smooth-scroll)
   *--------------------------------------------------------------------------
   */
  $('.js-smooth-scroll').click(function () {
    smoothScrollToElement(this);
  });

  function smoothScrollToElement(el, speed) {
    var speed = speed || 800;
    var elementToScrollToID = $(el).attr('href');
    $('html, body').animate(
      {
        scrollTop: $(elementToScrollToID).offset().top - 10,
      },
      speed
    );
  }

  /**
   *--------------------------------------------------------------------------
   * Hide Header and Nav on on scroll down )
   *--------------------------------------------------------------------------
   */

  var didScroll;
  var lastScrollTop = 5;
  var delta = 40;
  var navbarHeight = $('.c-site-header').outerHeight();

  $(window).scroll(function (event) {
    didScroll = true;
  });

  setInterval(function () {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 50);

  function navUp() {
    $('.c-site-header')
      .removeClass('c-site-header__nav-down')
      .addClass('c-site-header__nav-up');
    $('.c-site-nav')
      .removeClass('c-site-nav__nav-down')
      .addClass('c-site-nav__nav-up');
    $('.c-top-bar')
      .removeClass('c-top-bar__nav-down')
      .addClass('c-top-bar__nav-up');
  }

  function navDown() {
    $('.c-site-header')
      .removeClass('c-site-header__nav-up')
      .addClass('c-site-header__nav-down');
    $('.c-site-nav')
      .removeClass('c-site-nav__nav-up')
      .addClass('c-site-nav__nav-down');
    $('.c-top-bar')
      .removeClass('c-top-bar__nav-up')
      .addClass('c-top-bar__nav-down');
  }

  function navTop() {
    $('.c-site-header')
      .removeClass('c-site-header__nav-up')
      .removeClass('c-site-header__nav-down');
    $('.c-site-nav')
      .removeClass('c-site-nav__nav-up')
      .removeClass('c-site-nav__nav-down');
    $('.c-top-bar')
      .removeClass('c-top-bar__nav-up')
      .removeClass('c-top-bar__nav-down');
  }

  function hasScrolled() {
    var st = $(this).scrollTop();
    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) return;

    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight) {
      // Scroll Down
      navUp();
    } else {
      // Scroll Up
      if (st + $(window).height() < $(document).height()) {
        navDown();
      }
      // else if ($(window).scrollTop() === 0) {
      //   $('.c-site-header').addClass('c-site-header__nav-top');
      //   $('.c-site-nav').addClass('c-site-nav__nav-top');
      //   $('.c-top-bar').addClass('c-top-bar__nav-top');
      // }
    }
    console.log(st);
    // if ( $window.scrollTop() >= 20 ) {
    //   navTop();
    // }

    if (st <= 240) {
      navTop();
    }

    lastScrollTop = st;
  }

  /**
   *--------------------------------------------------------------------------
   * Component: Modal
   *--------------------------------------------------------------------------
   */

  var $modal = $('.c-modal');
  var $modalOverlay = $('.c-modal-overlay');

  $('.js-modal-toggle').on('click', function (e) {
    e.preventDefault();
    var modalId = $(this).attr('data-modal-id');
    var $modal = $('#' + modalId);
    // toggle modal & overlay
    $modal.toggleClass('is-closed');
    $modalOverlay.toggleClass('is-closed');
  });

  // Close all modals and overlay when clicking on the overlay
  $modalOverlay.on('click', function (e) {
    $(this).addClass('is-closed');
    $('.c-modal').addClass('is-closed');
    stopVideo();
    var $audio = document.getElementById('audio');
    $audio.pause();
  });

  /**
   *--------------------------------------------------------------------------
   * Component: Video
   *--------------------------------------------------------------------------
   */
  var $allVideos = $('.o-video > iframe, object, embed');
  var $fluidEl = $('.o-video');

  // $ .data does not work on object/embed elements
  $allVideos.each(function () {
    $(this)
      .attr('data-aspectRatio', this.height / this.width)
      .removeAttr('height')
      .removeAttr('width');
  });

  $(window)
    .resize(function () {
      var newWidth = $fluidEl.width();

      $allVideos.each(function () {
        var $el = $(this);
        $el.width(newWidth).height(newWidth * $el.attr('data-aspectRatio'));
      });
    })
    .resize();

  function stopVideo() {
    var $frame = $('iframe.vimeo-video');

    // saves the current iframe source
    var vidsrc = $frame.attr('src');

    // sets the source to nothing, stopping the video
    $frame.attr('src', '');

    // sets it back to the correct link so that it reloads immediately on the next window open
    $frame.attr('src', vidsrc);
  }

  /**
   *--------------------------------------------------------------------------
   * SVG to Inline
   *--------------------------------------------------------------------------
   */
  $('img.svg').each(function () {
    var $img = $(this);
    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');

    $.get(
      imgURL,
      function (data) {
        // Get the SVG tag, ignore the rest
        var $svg = $(data).find('svg');

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== 'undefined') {
          $svg = $svg.attr('id', imgID);
        }
        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== 'undefined') {
          $svg = $svg.attr('class', imgClass + ' replaced-svg');
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr('xmlns:a');

        // Replace image with new SVG
        $img.replaceWith($svg);
      },
      'xml'
    );
  });

  /**
   *--------------------------------------------------------------------------
   * Twitter Handler
   *--------------------------------------------------------------------------
   */
  function handleTwitterIntentLinks(params) {
    if (window.__twitterIntentHandler) return;
    var intentRegex = /twitter\.com\/intent\/(\w+)/;
    var windowOptions = 'scrollbars=yes,resizable=yes,toolbar=no,location=yes';
    var width = 550;
    var height = 420;
    var winHeight = window.screen.height;
    var winWidth = window.screen.width;

    function handleIntent(e) {
      e = e || window.event;
      var target = e.target || e.srcElement;

      var m;
      var left;
      var top;

      while (target && target.nodeName.toLowerCase() !== 'a') {
        target = target.parentNode;
      }

      if (target && target.nodeName.toLowerCase() === 'a' && target.href) {
        m = target.href.match(intentRegex);
        if (m) {
          left = Math.round(winWidth / 2 - width / 2);
          top = 0;

          if (winHeight > height) {
            top = Math.round(winHeight / 2 - height / 2);
          }

          window.open(
            target.href,
            'intent',
            windowOptions +
              ',width=' +
              width +
              ',height=' +
              height +
              ',left=' +
              left +
              ',top=' +
              top
          );
          e.returnValue = false;
          e.preventDefault && e.preventDefault();
        }
      }
    }

    if (document.addEventListener) {
      document.addEventListener('click', handleIntent, false);
    } else if (document.attachEvent) {
      document.attachEvent('onclick', handleIntent);
    }
    window.__twitterIntentHandler = true;
  }
  handleTwitterIntentLinks();

  /**
   *--------------------------------------------------------------------------
   * Component: Contact Drawer
   *--------------------------------------------------------------------------
   */
  var $drawer = document.getElementById('drawer');
  var $drawerToggle = $('.js-toggle-drawer');
  var drawerIsOpen = false;

  $drawerToggle.on('click', function () {
    toggleDrawer();
  });

  function toggleDrawer() {
    if (!drawerIsOpen) {
      lockScroll();
      drawerIsOpen = true;
      classie.addClass($drawer, 'is-open');
    } else {
      unlockScroll();
      drawerIsOpen = false;
      classie.removeClass($drawer, 'is-open');
    }
  }

  function stickyContactButton() {
    var windowHeight = $(window).height();
    var pageHeight = $(document).height();
    var maxScroll = pageHeight - windowHeight;
    var contactButton = $('#contact-button');

    if (contactButton.length) {
      var contactButtonHeight = contactButton.height();
      var contactButtonTop = contactButton.offset().top;
      var trigger = contactButtonTop - windowHeight;
    }

    // console.log('Window height is: ' + windowHeight)
    // console.log('Page height is: ' + pageHeight)
    // console.log('Button top is: ' + contactButtonTop)
    // console.log('Trigger is: ' + trigger)
    // console.log('Max scroll pos: ' + maxScroll)

    $(window).on('scroll', function () {
      var scrollPosition = window.pageYOffset;

      // console.log(scrollPosition)

      if (scrollPosition >= 1000 && scrollPosition < trigger) {
        contactButton.addClass('is-fixed');
      } else {
        contactButton.removeClass('is-fixed');
      }

      if (scrollPosition >= 1000 + 100) {
        contactButton.addClass('is-visible');
      } else {
        contactButton.removeClass('is-visible');
      }

      if (scrollPosition >= trigger) {
        // console.log('triggered')
        contactButton.removeClass('is-visible');
      }
    });
  }

  if (window.location.href.indexOf('/work') > -1) {
    //stickyContactButton()
  } else {
    stickyContactButton();
  }
});
